define(function (require) {
    "use strict";

    var $ = require("jquery");
    var level1 = require("coreComponentsSupportLevel1");

    var EditDecorator = require("ui.plugins/edit-decorator/js/EditDecorator");
    var InlineInput = require("ui/inline-input/InlineInput");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var InlineTextarea = require("ui/inline-textarea/InlineTextarea");
    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");
    var PlusCompositeView = require("ui/plus-composite-view/PlusCompositeView");
    var Counter = require("ui/counter/Counter");
    var Banner = require("ui/banner/Banner");
    var URLComponent = require("ui/urlComponent/URLComponent");
    var ColorPicker = require("ui/color-picker/ColorPicker");
    var ImagePicker = require("ui/image-picker/ImagePicker");
    var ImageCarousel = require("ui/image-carousel/ImageCarousel");
    var Paging = require("ui/paging/Paging");
    var Gallery = require("ui.components/gallery/gallery");
    var SingleSelectController = require("ui/single-select/SingleSelectController");
    var FileUploadInput = require("ui/file-upload-input/FileUploadInput");
    var Singleselect = require("ui/singleselect-new/Singleselect");
    var Link = require("ui/link/Link");
    var NotificationLayer = require ("ui.components/notification-layer/NotificationLayerView");

    var UserModel = require("models/entities/UserModel");
    var UsersCollection = require("collections/entities/UsersCollection");
    var SettingsCollection = require("collections/SettingsCollection");

    return {
        ui:$.extend(level1.ui, {
            EditDecorator: EditDecorator,
            InlineInput: InlineInput,
            ToggleButton: ToggleButton,
            InlineTextarea: InlineTextarea,
            DropdownMenu: DropdownMenu,
            PlusCompositeView: PlusCompositeView,
            Counter: Counter,
            Banner: Banner,
            URLComponent: URLComponent,
            ColorPicker: ColorPicker,
            ImagePicker: ImagePicker,
            Paging: Paging,
            Gallery: Gallery,
            SingleSelectController: SingleSelectController,
            FileUploadInput: FileUploadInput,
            Singleselect: Singleselect,
            Link: Link,
            NotificationLayer: NotificationLayer
        }),
        data: $.extend(true, level1.data, {
            models: {
                UserModel: UserModel
            },
            collections: {
                UsersCollection: UsersCollection,
                SettingsCollection: SettingsCollection
            }
        })
    };
});